<script>
import Layout from "../../layouts/main";
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import {lichCongTacModel} from "@/models/lichCongTacModel";
import {CONSTANTS} from "@/helpers/constants";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import {congViecModel} from "@/models/congViecModel";
import {userModel} from "@/models/userModel";
import vue2Dropzone from "vue2-dropzone";
import moment from "moment";
import Switches from "vue-switches";

export default {
  page: {
    title: "Lịch công tác",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    DatePicker, Multiselect,
    'ckeditor-nuxt': () => {
      return import('@blowstack/ckeditor-nuxt')
    },
    vueDropzone: vue2Dropzone,
    Switches
  },
  data() {
    return {
      data: [],
      apiUrl: process.env.VUE_APP_API_URL,
      loaiLichCongTac: this.$route.params.loaiLichCongTac,
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      model: lichCongTacModel.baseJson(),
      modelCongViec: congViecModel.baseJson(),
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 50,
      pageOptions: [50, 80, 100],
      filter: null,
      filterOn: [],
      isBusy: false,
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: 'STT',
          label: 'STT',
          tdClass: 'text-center',
          sortable: false,
          thClass: 'hidden-sortable',
          thStyle: {width: '70px', minWidth: '70px', textAlign: 'center',},
        },
        {
          key: "ngayXepLich",
          label: "Từ ngày",
          class: "custom-table-lichcongtacc anhan",
          sortable: true,
          thClass: 'hidden-sortable',
          thStyle: {width: '150px', minWidth: '110px'},
        },
        {
          key: "chuTri",
          label: "Chủ trì",
          class: "custom-table-lichcongtaccanhan",
          thClass: 'hidden-sortable',
          sortable: false,
        },
        {
          key: 'congViec',
          label: "Công việc",
          thClass: 'hidden-sortable',
          sortable: false,
          thStyle: {width: '100px', minWidth: '50px'},
          class: "custom-table-lichcongtaccanhan text-center",
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: "custom-table-lichcongtaccanhan btn-process",
          thClass: 'hidden-sortable',
          thStyle: {width: '100px', minWidth: '120px'},
          sortable: false
        }
      ],
      fieldsDSCV: [
        {
          key: 'STT',
          label: 'STT',
          class: 'text-center',
          sortable: false,
          thClass: 'hidden-sortable',
          thStyle: {width: '50px', minWidth: '50px'},
        },
        {
          key: "tuNgay",
          label: "Ngày",
          sortable: true,
          thStyle: {width: '100px', minWidth: '100px'},
          class: "text-center"
        },
        {
          key: "thoiGian",
          label: "Thời gian",
          thClass: 'hidden-sortable',
          thStyle: {width: '100px', minWidth: '100px'},
          sortable: false,
          class: "text-center"
        },
        {
          key: 'noiDung',
          label: "Nội dung",
          thClass: 'hidden-sortable',
          sortable: false,
        },
        {
          key: 'diaDiem',
          label: "Địa điểm",
          thClass: 'hidden-sortable',
          thStyle: {width: '200px', minWidth: '200px'},
          sortable: false,
        },
        {
          key: 'thanhPhan',
          label: "Thành phần",
          thClass: 'hidden-sortable',
          sortable: false,
        },
        {
          key: 'ghiChu',
          label: "Ghi chú",
          thClass: 'hidden-sortable',
          thStyle: {width: '200px', minWidth: '100px'},
          sortable: false,
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: 'btn-process text-center',
          thStyle: {width: '100px', minWidth: '100px'},
          thClass: 'hidden-sortable',
          sortable: false
        }
      ],
      optionsUser: [],
      showCongViecModel: false,
      itemFilter: {
        ngayBatDau: null,
        ngayKetThuc: null,
        nguoiChuTris: null,
        congViec: null,
      },
      optionsDonVi: [],
      idUser: {
        id: null
      },
      user: userModel.baseJson(),
      nguoiChuTri: null,
      showThemCongViecModel: false,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'fontfamily', 'fontsize', '|',
            'bold', 'italic', 'underline', '|',
            'alignment', '|',
            'undo', 'redo'
          ],
          shouldNotGroupWhenFull: false
        },
        removePlugins: ['Title', 'ImageCaption'],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "files/upload-ckeditor",
          headers: {
            'Authorization': 'optional_token'
          }
        },
        style: {
          height: '100px',
          minHeight: '100px',
        }
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 10,
        maxFilesize: 30,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".pdf, .doc, .docx, .xls, .xlsx, .ppt, pptx",
        dropzoneClassName: "dropzonevue-box"
      },
      showDeleteModalCongViec : false,
      showModalThanhPhanKhacLCT: false,
      thanhPhanThamDuLCT: null,
      url: process.env.VUE_APP_API_URL + 'files/view/',
      canBoCungDonVi: [],
    };
  },
  validations: {
    model: {
      ngayXepLich: {required},
      chuTri: {required}
    },
    modelCongViec: {
      tuNgay: {required},
    }
  },
  created() {
    this.fnGetList();
    this.getUser();
    if (this.$route.params.loaiLichCongTac == null) {
      window.location.href = '/'
    }
    this.getID();
    this.getDonVi();
  },
  watch: {
    '$route.params.loaiLichCongTac': {
      deep: true,
      handler(val) {
        if (val == null) {
          window.location.href = '/'
        }
        this.loaiLichCongTac = val;
        this.$refs.tblList.refresh()
      }
    },
  },
  methods: {
    handleShowThemCongViecModal(id, data) {
      this.modelCongViec = congViecModel.baseJson();
      this.modelCongViec.lichCongTacId = id;
      this.modelCongViec.tuNgay = data.ngayXepLich;
      this.showThemCongViecModel = true;
    },
    asyncGetCanBoSoan(selectedOption, id) {
      this.canBoSoan = this.optionsUser.filter(x => x.donVi && x.donVi.id == selectedOption.id);
    },
    async getDonVi() {
      try {
        await this.$store.dispatch("donViStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsDonVi = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    getID() {
      const idstore = localStorage.getItem('auth-user');
      this.idUser.id = JSON.parse(idstore)?.user?.id;
      this.getUserById(this.idUser.id);
      return JSON.parse(idstore);
    },
    async getUserById(id) {
      await this.$store.dispatch("userStore/getById", id).then((res) => {
        this.user = userModel.toJson(res.data);
        this.asyncGetCanBoCungDonVi(this.user);
      })
    },
    handleCreate() {
      this.showModal = true;
      this.model = lichCongTacModel.baseJson();
    },
    async fnGetList() {
      await this.onPageChange();
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async onPageChange() {
      this.$refs.tblList?.refresh()
    },
    async handleUpdate(id) {
      await this.$store.dispatch("lichCongTacStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = lichCongTacModel.fromJson(res.data);
          this.showModal = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          this.$refs.tblList.refresh()
        }
      });
    },
    async handleDetail(id) {
      await this.$store.dispatch("lichCongTacStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = lichCongTacModel.fromJson(res.data);
          this.showDetail = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        await this.$store.dispatch("lichCongTacStore/delete", this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.fnGetList();
            this.showDeleteModal = false;
            this.$refs.tblList.refresh()
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          // });
        });
      }
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.model.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (this.loaiLichCongTac && this.loaiLichCongTac != null) {
          this.model.loaiLichCongTac = this.loaiLichCongTac;
        }
        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          // Update model
          await this.$store.dispatch("lichCongTacStore/update", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.fnGetList();
              this.showModal = false;
              this.$refs.tblList.refresh()
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        } else {
          // Create model
          await this.$store.dispatch("lichCongTacStore/create", lichCongTacModel.toJson(this.model)).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.fnGetList();
              this.showModal = false;
              this.$refs.tblList.refresh()
              this.model = {};
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.filter,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        loaiLichCongTac: this.loaiLichCongTac,
        nguoiChuTris: this.itemFilter.nguoiChuTris,
        congViec: this.itemFilter.noiDung,
        ngayBatDau: this.itemFilter.ngayBatDau,
        ngayKetThuc: this.itemFilter.ngayKetThuc
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("lichCongTacStore/getPagingParamsCaNhan", params)
        return promise.then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            let data = resp.data;
            this.totalRows = data.totalRows
            let items = data.data
            this.numberOfElement = items.length
            this.loading = false
            return items || []
          } else {
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },
    handleShowCongViecModal(id) {
      this.$router.push('/cong-viec/' + id);
    },
    clearSearch() {
      this.itemFilter.ngayBatDau = null;
      this.itemFilter.ngayKetThuc = null;
      this.itemFilter.nguoiChuTris = null;
      this.itemFilter.congViec = null;
    },
    removeThisFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.modelCongViec.uploadFiles.filter(x => {
          return x.fileId != idFile;
        })
        this.modelCongViec.uploadFiles = resultData;
      }
    },
    addThisFile(file, response) {
      if (this.modelCongViec) {
        if (this.modelCongViec.uploadFiles == null || this.modelCongViec.uploadFiles.length <= 0) {
          this.modelCongViec.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.modelCongViec.uploadFiles.push({
          fileId: fileSuccess.id,
          fileName: fileSuccess.fileName,
          ext: fileSuccess.ext
        })
      }
    },
    async handleSubmitThemCongViec(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.modelCongViec.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.modelCongViec.id != 0 &&
            this.modelCongViec.id != null &&
            this.modelCongViec.id
        ) {
          // Update model
          await this.$store.dispatch("lichCongTacStore/updateCongViec", this.modelCongViec).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.modelCongViec = congViecModel.baseJson();
              // this.handleDetail(this.$route.params.id)
              this.showThemCongViecModel = false;
             this.fnGetList();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        } else {
          // Create model
          await this.$store.dispatch("lichCongTacStore/createCongViec", this.modelCongViec).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.modelCongViec = congViecModel.baseJson();
              // this.handleDetail(this.$route.params.id)
              this.showThemCongViecModel = false;
              this.fnGetList();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    async handleUpdateCongViec(value) {
      await this.$store.dispatch("lichCongTacStore/getByIdCongViec", value).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.modelCongViec = res.data;
          this.showThemCongViecModel = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleDeleteCongViec() {
      if (this.modelCongViec.id != 0 && this.modelCongViec.id != null && this.modelCongViec.id) {
        await this.$store.dispatch("lichCongTacStore/deleteCongViec", this.modelCongViec).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.modelCongViec = congViecModel.baseJson();
            this.handleDetail(this.$route.params.id)
            this.showDeleteModalCongViec = false;
            this.fnGetList();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          // });
        });
      }
    },
    handleShowDeleteModalCongViec(value) {
      this.modelCongViec = value;
      this.showDeleteModalCongViec = true;
    },
    disabledBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today
    },
    disabledAfterToday(date) {
      if(this.modelCongViec && this.modelCongViec.tuNgay){
        let tuNgay = moment(this.modelCongViec.tuNgay, "DD/MM/YYYY");
        return tuNgay >= date;
      }
      return false;
    },
    handleSearch(){
      this.fnGetList()
    },
    handleShowFile(id) {
      let route = this.$router.resolve({ path: "/xem-tep-tin/" + id });
      window.open(route.href, "_blank");
    },
    handleDeleteFile(index) {
      if (this.modelCongViec) {
        if (this.modelCongViec.files) {
          this.modelCongViec.files.splice(index, 1);
        }
      }
    },
    showThanhPhanKhacLCT(cv) {
      this.showModalThanhPhanKhacLCT = true
      this.thanhPhanThamDuLCT = cv;
    },
    asyncGetCanBoCungDonVi(item) {
      this.canBoCungDonVi = this.optionsUser.filter(x => x.donVi && x.donVi.id == item.donVi.id);
    },
  }
}
</script>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark" v-if="this.$route.params.loaiLichCongTac == 'lctt'"> Lịch công tác trường</h4>
                <h4 class="font-size-18 fw-bold text-dark" v-else-if="this.$route.params.loaiLichCongTac == 'lctdv'"> Lịch công tác đơn vị</h4>
                <h4 class="font-size-18 fw-bold text-dark" v-else> Lịch công tác</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button  v-b-toggle.collapseSearch variant="light"
                          class="btn w-md btn-primary-outline me-2" size="sm">
                  <i class="fas fa-caret-down align-middle me-2"></i>
                  Tìm kiếm
                </b-button>
                <b-button
                    variant="primary"
                    class="btn w-md btn-primary"
                    @click="handleCreate"
                    size="sm"
                >
                  <i class="mdi mdi-plus align-middle me-2"></i> Thêm mới
                </b-button>
              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Ngày tạo -->
                    <div class="flex-grow-1 me-2">
                      <label class="mb-1">Ngày công tác</label>
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 me-2 mb-md-0 mb-2">
                          <date-picker v-model="itemFilter.ngayBatDau"
                                       format="DD/MM/YYYY"
                                       value-type="format"
                          >
                            <div slot="input">
                              <input v-model="itemFilter.ngayBatDau"
                                     v-mask="'##/##/####'" type="text" class="form-control"
                                     placeholder="Nhập ngày bắt đầu"/>
                            </div>
                          </date-picker>
                        </div>
                        <div class="flex-grow-1 me-2 mb-md-0 mb-2">
                          <date-picker v-model="itemFilter.ngayKetThuc"
                                       format="DD/MM/YYYY"
                                       value-type="format"
                          >
                            <div slot="input">
                              <input v-model="itemFilter.ngayKetThuc"
                                     v-mask="'##/##/####'" type="text" class="form-control"
                                     placeholder="Nhập ngày kết thúc"/>
                            </div>
                          </date-picker>
                        </div>
                      </div>
                    </div>
                    <!-- Người tạo -->
                    <div class="flex-grow-1 me-2">
                      <label class="mb-1"> Người chủ trì</label>
                      <multiselect
                          v-model="itemFilter.nguoiChuTris"
                          :options="optionsUser"
                          :multiple=true
                          track-by="id"
                          label="fullName"
                          placeholder="Chọn người chủ trì"
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong>{{ option.fullName }}</strong>

                          <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                        </template>
                        <template slot="option" slot-scope="{ option }">
                          <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                            <span v-if="option.donVi" class="option__small"
                                  style="color:green">{{ option.donVi.ten }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <!-- Từ khoá -->
                    <div class="flex-grow-1">
                      <label class="mb-1"> Nội dung</label>
                      <input size="sm" type="text" name="untyped-input" class="form-control"
                             v-model="itemFilter.noiDung"
                             placeholder="Nội dung ..."/>
                    </div>
                    <!--  Xử lý -->
                    <div class="flex-grow-0 ms-2">
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="handleSearch" variant="light"
                                    class="btn w-md btn-primary me-2" size="md">
                            <i class="fas fa-search align-middle me-2"></i>
                            Tìm kiếm
                          </b-button>
                        </div>
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="clearSearch" variant="light"
                                    class="btn w-md btn-secondary me-2" size="md">
                            <i class="fas fa-redo-alt align-middle me-2"></i>
                            Làm mới
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive-sm">
          <b-table
              class="datatables custom-table"
              :items="myProvider"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              ref="tblList"
              primary-key="id"
              :busy.sync="isBusy"
              table-class="cs-table-spacing 20px"
              tbody-tr-class="table-lichcongtaccanhan"
          >
            <template v-slot:cell(STT)="data">
              <div class="w-100 d-md-flex justify-content-md-center">
                <p class="lct-icon">{{ data.index + ((currentPage - 1) * perPage) + 1 }}</p>
              </div>
            </template>
            <template v-slot:cell(chuTri)="data">
              <div v-if="data.item.chuTri  && data.item.chuTri.length > 0"
                   style="display: flex; flex-direction: column; margin-left: 10px">
                <div v-for="(value, index) in data.item.chuTri" :key="index">
                  {{ value.fullName }} - {{ value.donVi.ten }}
                </div>
              </div>

            </template>
            <template v-slot:cell(congViec)="data">
              <!--              <button-->
              <!--                  type="button"-->
              <!--                  size="sm"-->
              <!--                  class="btn btn-primary btn-sm"-->
              <!--                  data-toggle="tooltip" data-placement="bottom" title="Cập nhật"-->
              <!--                  v-on:click="handleShowCongViecModal(data.item.id)">-->

              <!--                        <span v-if="data.item.congViecs && data.item.congViecs.length>0">-->
              <!--                           {{data.item.congViecs.length}}-->
              <!--                        </span>-->
              <!--                <span v-else>0</span>-->
              <!--              </button>-->
              <button
                  type="button"
                  size="sm"
                  class="btn btn-primary btn-sm"
                  data-toggle="tooltip" data-placement="bottom" title="Công việc"
                  v-b-toggle="'collapse-' + data.item.id"
                  v-on:click="data.toggleDetails">
                        <span v-if="data.item.congViecs && data.item.congViecs.length>0">
                           {{ data.item.congViecs.length }}
                        </span>
                <span v-else>0</span>
              </button>
            </template>
            <template v-slot:cell(process)="data">
              <button
                  type="button"
                  size="sm"
                  class="btn btn-detail btn-sm"
                  data-toggle="tooltip" data-placement="bottom" title="Chi tiết"
                  v-b-toggle="'collapse-' + data.item.id"
                  @click="data.toggleDetails"
              >
                <i class="fas fa-eye"></i>
              </button>
              <button
                  type="button"
                  size="sm"
                  class="btn btn-edit btn-sm"
                  data-toggle="tooltip" data-placement="bottom" title="Cập nhật"
                  v-on:click="handleUpdate(data.item.id)">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button
                  type="button"
                  size="sm"
                  class="btn btn-delete btn-sm"
                  data-toggle="tooltip" data-placement="bottom" title="Xóa"
                  v-on:click="handleShowDeleteModal(data.item.id)">
                <i class="fas fa-trash-alt"></i>
              </button>
            </template>
            <template v-slot:cell(ten)="data">&nbsp;&nbsp;
              {{ data.item.ten }}
            </template>
            <template #row-details="data">
              <b-collapse :id="`collapse-${data.item.id}`" class="">
                <div class="ps-md-5 ps-0 my-4">
                  <div v-for="(data, index) in data.item.congViecs" :key="index" class="job-box">
                    <div class="card">
                      <div class="card-body">
                        <!--  process thêm công việc-->
                        <div class="cs-btn-box">
                          <button
                              type="button"
                              size="sm"
                              class="btn btn-edit btn-sm"
                              data-toggle="tooltip" data-placement="bottom" title="Cập nhật"
                              v-on:click="handleUpdateCongViec(data)">
                            <i class="fas fa-pencil-alt"></i>
                          </button>
                          <button
                              type="button"
                              size="sm"
                              class="btn btn-delete btn-sm"
                              data-toggle="tooltip" data-placement="bottom" title="Xóa"
                              v-on:click="handleShowDeleteModalCongViec(data)">
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                        <div class="row mb-2">
                          <div class="col-sm-1 col-12 icon-box">
                            <i class="mdi mdi-calendar mdi-24px icon-list-job"></i>
                          </div>
                          <div class="col-sm-8 col-12">
                            <div v-if="data.noiDung" class="job-title" :inner-html.prop="data.noiDung"></div>
                            <div v-else class="job-title">Không có nội dung.</div>
                          </div>
                          <div class="col-sm-3 col-12 text-end">
                            <div v-if="data.denNgay"><p class="fw-bold"> {{ data.tuNgay }} - {{ data.denNgay }}</p>
                            </div>
                            <div v-else><p class="fw-bold">{{ data.tuNgay }} </p></div>
                          </div>
                        </div>
                        <hr>
                        <div class="row mb-2" v-if="data.thoiGian || data.diaDiem">
                          <div class="col-1 text-center">
                            <i class="mdi mdi-map-marker mdi-24px text-primary"></i>
                          </div>
                          <div class="col-8">
                            <p class="mb-1 text-muted text-uppercase"> Địa điểm</p>
                            <div class="cs-color-dark fw-bold font-size-15" v-if="data.diaDiem"
                                 :inner-html.prop="data.diaDiem"></div>
                          </div>
                          <div class="col-3 text-end ">
                            <div class="fw-bold" v-if="data.thoiGian"><i class="far fa-clock"></i> {{ data.thoiGian }}
                            </div>
                          </div>
                        </div>
                        <div class="row mb-2" v-if="data.thanhPhanThamDu || data.thanhPhan">
                          <div class="col-1 text-center">
                            <i class="mdi mdi-account-group mdi-24px text-primary"></i>
                          </div>
                          <div class="col-11">
                            <div v-if="data.thanhPhanThamDu && data.thanhPhanThamDu.length > 0"
                                 class="mb-3"
                            >
                              <p class="mb-1 text-muted text-uppercase"> Thành phần tham dự</p>
                              <div class="badge badge-soft-success me-1 font-size-13 px-3 py-2"
                                   v-for="(value, index) in data.thanhPhanThamDu" :key="index">
                                <div v-if="index < 5">
                                  {{ value.fullName }} - <span>{{ value.donVi.ten }}</span>
                                </div>
                              </div>
                              <a v-if="data.thanhPhanThamDu.length > 5" @click="showThanhPhanKhacLCT(data.thanhPhanThamDu)" class="badge badge-soft-info cs-cursor"><i
                                  class="fas fa-eye"></i> Xem chi tiết</a>
                            </div>
                            <div v-if="data.thanhPhan">
                              <p class="mb-1 text-muted text-uppercase"> Thành phần khác</p>
                              <div class="cs-color-dark" :inner-html.prop="data.thanhPhan"></div>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-2" v-if="data.files && data.files.length > 0">
                          <div class="col-1 text-center">
                            <i class="mdi mdi-link-variant mdi-24px text-primary"></i>
                          </div>
                          <div class="col-11">
                            <p class="mb-1 text-muted text-uppercase"> Tệp tin đính kèm</p>
                            <div v-if="data.files" class="col-sm-12">
                              <div class="mb-1 d-flex file-box">
                                <div
                                    v-for="(value, index) in data.files" :key="index"
                                    class="mb-1 me-2"
                                    style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px;"
                                >
                                  <a
                                      :href="`${apiUrl}files/view/${value.fileId}`"
                                      class=" fw-medium"
                                  ><i
                                      class="fas fa-cloud-download-alt text-primary mx-2"
                                  ></i>
                                    [Tải về]
                                  </a>
                                  <a v-if="value.ext=='.pdf'" style="cursor: pointer"
                                     @click="handleShowFile(value.fileId)"
                                     class="text-danger fw-medium">
                                    [Xem]
                                  </a>
                                  <span
                                      style="font-weight: 500; color: #2F93E0"
                                      class="px-2"
                                  >
                                        {{ value.fileName }}
                                      </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-button
                      class="btn-job"
                      @click="handleShowThemCongViecModal(data.item.id, data.item)"
                  >
                    <i class="mdi mdi-plus-thick me-1"></i>
                    Thêm công việc
                  </b-button>
                  <div class="btn-close-job">
                    <button
                        type="button"
                        size="sm"
                        pill
                        class="btn btn-light"
                        data-toggle="tooltip" data-placement="bottom" title="Chi tiết"
                        v-b-toggle="'collapse-' + data.item.id"
                        @click="data.toggleDetails"
                    >
                      <i class="fas fa-angle-up"></i>
                    </button>
                  </div>
                </div>
              </b-collapse>
            </template>
          </b-table>
          <template v-if="isBusy">
            <div align="center">Đang tải dữ liệu</div>
          </template>
          <template v-if="totalRows <= 0 && !isBusy">
            <div align="center">Không có dữ liệu</div>
          </template>
        </div>
        <!-- Paginnation -->
        <div>
          <div class="row mb-2">
            <div class="col-sm-12 col-md-6">
              <div style="display: flex; justify-content: start; align-items: center">
                <div style="margin-right: 20px" class="">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Hiện
                      <b-form-select
                          class="form-select form-select-sm"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                      ></b-form-select
                      >&nbsp;dòng
                    </label>
                  </div>

                </div>
                <div class="">
                  <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div
                  class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <b-modal
        v-model="showDeleteModal"
        centered
        title="Xóa dữ liệu"
        title-class="font-18"
        no-close-on-backdrop
        hide-header
    >
      <div class="card my-4 pt-2 shadow-none">
        <div class="card-body p-4">
          <div class="text-center">
            <div class="avatar-md mx-auto mb-4">
              <div
                  class="avatar-title bg-light rounded-circle text-danger h1"
              >
                <i class="mdi mdi-trash-can"></i>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-xl-10">
                <h4 class="text-dark">Xoá dữ liệu!</h4>
                <p class="text-muted font-size-14 mb-0">
                  Dữ liệu đã xoá sẽ không được phục hồi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  variant="light"
                  class="btn btn-light w-md"
                  v-on:click="showDeleteModal = false">
          Đóng
        </b-button>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  variant="danger"
                  type="button"
                  class="w-md"
                  v-on:click="handleDelete">
          Xóa
        </b-button>
      </template>
    </b-modal>
    <!--    Xóa công việc-->
    <b-modal
        v-model="showDeleteModalCongViec"
        centered
        title="Xóa dữ liệu"
        title-class="font-18"
        no-close-on-backdrop
        hide-header
    >
      <div class="card my-4 pt-2 shadow-none">
        <div class="card-body p-4">
          <div class="text-center">
            <div class="avatar-md mx-auto mb-4">
              <div
                  class="avatar-title bg-light rounded-circle text-danger h1"
              >
                <i class="mdi mdi-trash-can"></i>
              </div>
            </div>

            <div class="row justify-content-center">
              <div class="col-xl-10">
                <h4 class="text-dark">Xoá công việc!</h4>
                <p class="text-muted font-size-14 mb-0">
                  Dữ liệu đã xoá sẽ không được phục hồi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  variant="light"
                  class="btn btn-light w-md"
                  v-on:click="showDeleteModalCongViec = false">
          Đóng
        </b-button>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  variant="danger"
                  type="button"
                  class="w-md"
                  v-on:click="handleDeleteCongViec">
          Xóa
        </b-button>
      </template>
    </b-modal>

    <!--                  Modal create -->
    <b-modal
        v-model="showModal"
        title="Thông tin lịch công tác"
        title-class="text-black font-18"
        body-class="p-3"
        header-class="cs-modal-header"
        hide-footer
        centered
        no-close-on-backdrop
        size="lg"
    >
      <form @submit.prevent="handleSubmit"
            ref="formContainer">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label class="text-left">Ngày bắt đầu</label>
              <span style="color: red">&nbsp;*</span>
              <input type="hidden" v-model="model.id"/>
              <date-picker v-model="model.ngayXepLich"
                           format="DD/MM/YYYY"
                           value-type="format"
                           :class="{
                                'is-invalid':
                                  submitted && $v.model.ngayXepLich.$error,
                                }"
                           :disabled-date="disabledBeforeToday"
                           :editable="false"
              >
              </date-picker>
              <div
                  v-if="submitted && !$v.model.ngayXepLich.required"
                  class="invalid-feedback"
              >
                Ngày xếp lịch công được trống
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label class="text-left">Chủ trì</label>
              <span style="color: red">&nbsp;*</span>
              <multiselect
                  v-model="model.chuTri"
                  :options="optionsUser"
                  :multiple=true
                  track-by="id"
                  label="fullName"
                  placeholder="Chọn người chủ trì"
                  deselect-label="Nhấn để xoá"
                  selectLabel="Nhấn enter để chọn"
                  selectedLabel="Đã chọn"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.chuTri.$error,
                                }"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.fullName }}</strong>

                  <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                </template>
                <template slot="option" slot-scope="{ option }">
                  <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                    <span v-if="option.donVi" class="option__small"
                          style="color:green">{{ option.donVi.ten }}</span>
                  </div>
                </template>
              </multiselect>
              <div
                  v-if="submitted && !$v.model.chuTri.required"
                  class="invalid-feedback"
              >
                Người chủ trì không được trống
              </div>
            </div>
          </div>
        </div>
        <div class="text-end pt-2 mt-3">
          <b-button variant="light" class="w-md" size="sm" @click="showModal = false">
            Đóng
          </b-button>
          <b-button type="submit" variant="primary" size="sm" class="ms-1 w-md">
            Lưu
          </b-button>
        </div>
      </form>
    </b-modal>

    <!-- Modal thêm công việc -->
    <b-modal
        v-model="showThemCongViecModel"
        title="Thông tin công việc"
        title-class="text-black font-18"
        body-class="p-3"
        header-class="cs-modal-header"
        hide-footer
        centered
        no-close-on-backdrop
        size="xl"
    >
      <template #modal-header="{ }">
        <!-- Emulate built in modal header close button action -->
        <h5> Thông tin công việc</h5>
        <div class="text-end">
          <b-button variant="light" class="w-md" size="sm" @click="showThemCongViecModel = false">
            Đóng
          </b-button>
          <b-button @click="handleSubmitThemCongViec" variant="primary" size="sm" class="ms-1 w-md">
            Lưu
          </b-button>
        </div>
      </template>
      <form @submit.prevent="handleSubmitThemCongViec"
            ref="formContainer">
        <div class="row">
          <!-- Thời gian -->
          <div class="col-12">
            <div class="mb-3 d-flex justify-content-start align-items-start flex-sm-nowrap flex-wrap gap-2">
              <label for="" class="w-md">Thời gian <span class="text-danger">(*)</span></label>
              <div class="">
                <div class="d-flex justify-content-start align-items-center gap-2 flex-wrap">
                  <div class="d-flex justify-content-center gap-2">
                    <div class="">
                      <input type="hidden" v-model="modelCongViec.id"/>
                      <date-picker v-model="modelCongViec.tuNgay"
                                   format="DD/MM/YYYY"
                                   value-type="format"
                                   :disabled="true"
                      >
                      </date-picker>
                    </div>
                    <div class="">
                      <input v-model.trim="modelCongViec.thoiGian" v-mask="'##:##'" type="text" class="form-control"
                             placeholder="##:##"/>
                    </div>
                  </div>
                  <div class="d-flex align-items-center middle">
                    ~
                  </div>
                  <div class="d-flex justify-content-center gap-2">
                    <div class="">
                      <date-picker v-model="modelCongViec.denNgay"
                                   format="DD/MM/YYYY"
                                   value-type="format"
                                   :disabled-date="disabledAfterToday"
                                   :editable="false"
                      >
                      </date-picker>
                    </div>
                    <div class="">
                      <input v-model.trim="modelCongViec.thoiGianDenNgay" v-mask="'##:##'" type="text"
                             class="form-control"
                             placeholder="##:##"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Nội dung -->
          <div class="col-12">
            <div class="mb-3 d-flex justify-content-start align-items-start flex-sm-nowrap flex-wrap gap-2">
              <label for="" class="w-md">Nội dung <span class="text-danger">(*)</span></label>
              <div class="w-100 cs-minHeight-ckeditor">
                <textarea class="form-control" v-model="modelCongViec.noiDung" rows="3">
                </textarea>
              </div>
            </div>
          </div>
          <!-- Tham dự -->
          <div class="col-12">
            <div class="mb-3 d-flex justify-content-start align-items-start flex-sm-nowrap flex-wrap gap-2">
              <label class="w-md">Tham dự</label>
              <multiselect
                  :multiple="true"
                  v-model="modelCongViec.thanhPhanThamDu"
                  :options="optionsUser"
                  track-by="id"
                  label="fullName"
                  placeholder="Chọn người tham dự"
                  deselect-label="Nhấn để xoá"
                  selectLabel="Nhấn enter để chọn"
                  selectedLabel="Đã chọn"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.fullName }}</strong>

                  <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                </template>
                <template slot="option" slot-scope="{ option }">
                  <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                    <span v-if="option.donVi" class="option__small"
                          style="color:green">{{ option.donVi.ten }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3 d-flex justify-content-start align-items-start flex-sm-nowrap flex-wrap gap-2">
              <label class="w-md">Thành phần khác</label>
              <div class="w-100 cs-minHeight-ckeditor">
                <ckeditor-nuxt v-model="modelCongViec.thanhPhan" :config="editorConfig"/>
              </div>
            </div>
          </div>
          <!-- Địa điểm -->
          <div class="col-12">
            <div class="mb-3 d-flex justify-content-start align-items-start flex-sm-nowrap flex-wrap gap-2">
              <label for="" class="w-md">Địa điểm</label>
              <div class="w-100 cs-minHeight-ckeditor">
                <ckeditor-nuxt v-model="modelCongViec.diaDiem" :config="editorConfig"/>
              </div>
            </div>
          </div>
          <!-- Ghi chú -->
          <div class="col-12">
            <div class="mb-3 d-flex justify-content-start align-items-start flex-sm-nowrap flex-wrap gap-2">
              <label for="" class="w-md">Ghi chú</label>
              <div class="w-100 cs-minHeight-ckeditor">
                <ckeditor-nuxt v-model="modelCongViec.ghiChu" :config="editorConfig"/>
              </div>
            </div>
          </div>
          <!-- Màu sắc -->
          <div class="col-4">
            <div class="mb-3 d-flex justify-content-start align-items-start flex-sm-nowrap flex-wrap gap-2">
              <label for="" class="w-md">Màu sắc</label>

              <div class="w-100">
                <switches  v-model="modelCongViec.isShowColor" type-bold="true" color="primary"></switches>
                <input
                    v-if="modelCongViec.isShowColor"
                    type="color"
                    class="form-control-color mw-100 form-control"
                    id="example-color-input"
                    v-model="modelCongViec.mauSac"
                />
              </div>
            </div>
          </div>
          <!-- Đính kèm -->
          <div class="col-lg-12">
            <div class="mb-3 d-flex justify-content-start align-items-start flex-sm-nowrap flex-wrap gap-2">
              <label for="" class="w-md">Tệp tin đính kèm</label>
              <div class="w-100">
                <div v-if="modelCongViec.files != null && modelCongViec.files.length >= 0">
                  <div v-for="(file, index) in modelCongViec.files" :key="file.fileId">
                    <a
                        v-if="file.ext == '.pdf'"
                        :href="`/xem-tep-tin/${file.fileId}`"
                        class=" fw-medium"
                        target="_blank"
                    ><i
                        :class="`mdi font-size-16 align-middle me-2`"
                    ></i>
                      {{ index + 1 }}: {{ file.fileName }}</a
                    >
                    <a
                        v-else
                        :href="`${apiUrl}files/view/${file.fileId}`"
                        class=" fw-medium"
                        target="_blank"
                    ><i
                        :class="`mdi font-size-16 align-middle me-2`"
                    ></i>
                      {{ index + 1 }}: {{ file.fileName }}</a
                    >
                    <button
                        type="button"
                        size="sm"
                        class="btn btn-outline btn-sm"
                        data-toggle="tooltip" data-placement="bottom" title="Xóa"
                        v-on:click="handleDeleteFile(index)">
                      <i class="fas fa-trash-alt text-danger me-1"></i>
                    </button>
                  </div>
                </div>
                <div style="color: red"> Lưu ý: .pdf, word, excel, ppt, .rar, .zip</div>
                <vue-dropzone id="dropzone" ref="myVueDropzone" :use-custom-slot="true"
                              :options="dropzoneOptions" v-on:vdropzone-removed-file="removeThisFile"
                              v-on:vdropzone-success="addThisFile">
                  <div class="">
                    <i class="display-1 text-muted bx bxs-cloud-upload" style="font-size: 70px"></i>
                    <p class="font-size-18">
                      Kéo thả tệp tin hoặc bấm vào để tải tệp tin
                    </p>
                  </div>
                </vue-dropzone>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
        v-model="showModalThanhPhanKhacLCT"
        centered
        title="Chi tiết công việc"
        title-class="font-18"
        no-close-on-backdrop
        size="lg"
        hide-header
        hide-footer
        modal-class="cs-modal-chitietLCT"
    >
      <div class="row">
        <div class="col-12 position-relative">
          <a class="cs-close-modal" @click="showModalThanhPhanKhacLCT = false"><i class="mdi mdi-close-thick"></i></a>
        </div>
      </div>
      <div class="row px-3 mt-3" v-if="thanhPhanThamDuLCT">
        <div class="col-12 px-4">
          <!-- Thành phần tham dự-->
          <div v-if="thanhPhanThamDuLCT" class="row mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="text-bold text-black">Thành phần tham dự</h5>
              <p class="badge badge-soft-teal font-size-15">{{thanhPhanThamDuLCT.length}}</p>
            </div>
            <div v-if="thanhPhanThamDuLCT">
              <div v-for="(tptd, index) in thanhPhanThamDuLCT" :key="index" class="cs-row">
                <div class="row equal-height-row ">
                  <div class="col-md-6 col-12">
                    <div class="row equal-height-row">
                      <div class="col-3 justify-content-center">
                      <span v-if="tptd.avatar">
                      <b-img
                          :src=" url + `${tptd.avatar.fileId}`"
                          alt="Avatar"
                          class="rounded-circle header-profile-user"
                      >
                      </b-img>
                    </span>
                        <span v-else>
                      <img
                          class="rounded-circle header-profile-user"
                          src="@/assets/images/users/user-4.jpg"
                          alt="Avatar"
                      />
                    </span>
                      </div>
                      <div class="col-9 justify-content-center">
                        <p v-if="tptd.fullName" class="mb-0 text-black">{{ tptd.fullName }}</p>
                        <div v-if="tptd.email" class="d-flex align-items-center">
                          <i class="mdi mdi-email text-warning me-1"></i>
                          <p class="mb-0">{{ tptd.email }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 justify-content-center">
                    <p class="mb-0 cs-bg-text">
                      <span class="">{{ tptd.donVi.ten }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

  </div>
</template>
<style>
.td-stt {
  text-align: center;
  width: 50px;
}

.td-xuly {
  text-align: center;
  width: 130px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

@media only screen and (max-width: 768px) {
  /*
  Label the data
  */
  .table-lichcongtaccanhan > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .table-lichcongtaccanhan > td:nth-of-type(2):before {
    content: "Từ ngày";
    font-weight: bold;
    color: #00568c;
  }

  .table-lichcongtaccanhan > td:nth-of-type(3):before {
    content: "Chủ trì";
    font-weight: bold;
    color: #00568c;
  }

  .table-lichcongtaccanhan > td:nth-of-type(4):before {
    content: "Công việc";
    font-weight: bold;
    color: #00568c;
  }

  .table-lichcongtaccanhan > td:nth-of-type(5):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }
}

.cs-modal-header {
  background-color: #f2f6fc;
  border: none;
}

.multiselect {
  min-height: 34px;
}

.multiselect__select {
  height: 34px;
}

.b-table-details.table-lichcongtaccanhan > td {
  padding-left: 0% !important;
}

.b-table-details.table-lichcongtaccanhan > td:before {
  content: "";
}
</style>
